import {  Section } from "../interfaces/course";

export interface FilterObj {
    title: string;
    value: number;
    category: string;
}

export const transformedArrayForFilters = (object: Record<string, number>): FilterObj[] => {
    return Object.entries(object).map(([key, value]) => {
        let title = key.split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
            console.log(title)
        const category = key;
        return {
            title: title,
            value: value,
            category: category
        };
    });
};



export function processData(sections: Section[]): { acceleratorType: Record<string, number>, drillType: Record<string, number>} {
    const acceleratorType: Record<string, number> = {};
    const drillType: Record<string, number> = {};
    const uniqueCourseIds = new Set<number>();


    sections?.forEach(section => {
        section.things.forEach(thing => {
            // if thing.ID does not exist alreaady
            if (!uniqueCourseIds.has(thing.ID)) {
                uniqueCourseIds.add(thing.ID);

                thing.filters.forEach(filter => {
                    if (filter.startsWith('accelerator:')) {
                        const category = filter.split(':')[1];
                        acceleratorType[category] = acceleratorType[category] ? acceleratorType[category] + 1 : 1;
                    } else if (filter.startsWith('drill:')) {
                        const status = filter.split(':')[1];
                        drillType[status] = drillType[status] ? drillType[status] + 1 : 1;
                    }
                });
            }
        });
    });

    return { acceleratorType,drillType };
}



export function getFilterPrefix(filterType: string): string {
    switch (filterType) {
        case "Accelerator":
            return "accelerator:";
        case "Drill":
            return "drill:";
        default:
            return "";
    }
}


export const isSelectedFilterNotEmpty = (selectedFilters:Record<string, string[]>) => {
    return Object.values(selectedFilters).some(filters => filters.length > 0);
};